import { closeModal } from "../helpers/useModal";
import { CloseIcon } from "../icons/CloseIcon";

type props = {
  id: string
  className?: string
  heading?: string
  content: React.ReactNode,
  type?: string,
  scrollTarget?: string
}

export function Modal ({ id, className, heading, content, type = 'modal', scrollTarget = '.modal-body' }: props) {
  if (!id) return null

  const close = () => {
    closeModal(id)
    sessionStorage.removeItem('returnTo')
  }

  return (
    <div className={`modal ${className}`} id={id} data-modal={type} data-scroll-target={scrollTarget}>
      <div className="modal-overlay" onClick={close}></div>
      <div className="modal-body">
        <div className="modal-header">
          <div className="modal-header-tab z-50"></div>
          <h2 className="modal-heading">{heading}</h2>
          <button className="modal-close" aria-label="close-modal" onClick={close}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          {content}
        </div>
      </div>
    </div>
  )
}
